import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import { TextField, Button } from "@material-ui/core";
import getStipendi from "../services/getStipendi";
import moment from 'moment';
import getF24Tasse from "../services/getF24Tasse";
import getF24Ritenute from "../services/getF24Ritenute";
import editF24Tasse from "../services/editF24Tasse";
import editF24Ritenute from "../services/editF24Ritenute";
import editF24Stipendio from "../services/editF24Stipendio";
import getF24Iva from "../services/getF24Iva";
import editF24Iva from "../services/editF24Iva";
import reloadIVA from "../services/reloadIVA";
import getF24Stipendi from "../services/getF24Stipendi";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class F24 extends React.Component {

  constructor(props){
    super (props)

    this.stipendi = [];
    this.f24tasse = [];
    this.f24IVA = [];
    this.f24ritenute = [];

    let sp = moment().format('MM/yyyy');
    let t = moment().format('MM/yyyy');
    let ep = moment(t, 'MM/yyyy').add(1, 'year').startOf('month').format('MM/yyyy');
      
    this.state = {
        isLoading: true, 
        startPeriod: sp,
        endPeriod: ep,
        date: [], 
        isLoading: true
    };

  }

  async reload() {
    this.setState({ isLoading: true });
    this.generateDate();

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });

    var tasse = await getF24Tasse(username, token);
    var iva = await getF24Iva(username, token);
    var ritenute = await getF24Ritenute(username, token);
    var stipendi = await getF24Stipendi(username, token);
    tasse = tasse !== '' ? JSON.parse(tasse) : []
    ritenute = ritenute !== '' ? JSON.parse(ritenute) : []
    iva = iva !== '' ? JSON.parse(iva) : []
    stipendi = stipendi !== '' ? JSON.parse(stipendi) : []

    this.f24tasse = [];
    this.f24IVA = [];
    this.f24ritenute = [];
    this.f24Stipendi = [];

    this.state.date.forEach(d => {
        let t = tasse.find(tassa => tassa.mese === d);
        if (t) {
            this.f24tasse.push(t.importo)
        } else {
            this.f24tasse.push('')
        }

        let r = ritenute.find(rit => rit.mese === d);
        if (r) {
            this.f24ritenute.push(r.importo)
        } else {
            this.f24ritenute.push('')
        }

        let i = iva.find(iv => iv.mese === d);
        if (i) {
            this.f24IVA.push({ mese: i.mese, importo: i.importo, edited: i.edited })
        } else {
            this.f24IVA.push({ mese: d, importo: '', edited: '0' })
        }
        
        let s = stipendi.find(st => st.mese === d);
        if (s) {
            this.f24Stipendi.push(s.importo)
        } else {
            this.f24Stipendi.push('')
        }
    })

    this.setState({  isLoading: false });
  }

  async componentDidMount(){
    await this.reload();
  }

  generateDate() {
    var date = [];
    let d = moment(this.state.startPeriod, 'MM/yyyy')
    while (d.format('MM/yyyy') !== this.state.endPeriod) {
        date.push(d.format('MM/yyyy'));
        d.add(1, 'month');
    }
    date.push(this.state.endPeriod);
    this.setState({ date })
  }

  changeRitenuta(ind, ritenuta) {
    this.f24ritenute[ind] = this.getImporto(ritenuta);
    this.setState({});
  }

  getImporto(importo) {
    var t = importo.replace(/\./g, '');
    if(/[^0-9,]+/.test(t)) {
        t = t.replace(/[^0-9]+/g, '');
    }
    var chunks = t.split(',');
    chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    t = chunks.join(',');
    return t.trim();
}

  changeTasse(ind, tassa) {
    this.f24tasse[ind] = this.getImporto(tassa);
    this.setState({});
  }

  changeStipendi(ind, tassa) {
    this.f24Stipendi[ind] = this.getImporto(tassa);
    this.setState({});
  }

  changeIVA(ind, iva) {
    this.f24IVA[ind].importo = this.getImporto(iva);
    this.f24IVA[ind].edited = '1';
    this.setState({});
  }

  render () {

    if (this.state.isLoading)
        return <Loading />;

    return (
      <div id={Math.random()}>

        <PageTitle title="F24" button="SALVA" onClick={async () => {

            this.setState({ isLoading: true });

            var finalTasse = await getF24Tasse(username, token);
            finalTasse = finalTasse !== '' ? JSON.parse(finalTasse) : []
            var finalRitenute = await getF24Ritenute(username, token);
            finalRitenute = finalRitenute !== '' ? JSON.parse(finalRitenute) : []
            var finalStipendi = await getF24Stipendi(username, token);
            finalStipendi = finalStipendi !== '' ? JSON.parse(finalStipendi) : []

            this.f24tasse.forEach((f, i) => {
                let data = this.state.date[i];
                var index = 0;

                let tassa = finalTasse.find((t, it) => {
                    index = it
                    return t.mese === data
                });
                
                if (!tassa) {
                    if (f !== '')
                        finalTasse.push({ mese: data, importo: f });
                } else 
                    finalTasse[index].importo = f;
            });

            this.f24ritenute.forEach((f, i) => {
                let data = this.state.date[i];
                var index = 0;

                let ritenuta = finalRitenute.find((t, it) => {
                    index = it
                    return t.mese === data
                });
                
                if (!ritenuta) {
                    if (f !== '')
                        finalRitenute.push({ mese: data, importo: f });
                } else 
                    finalRitenute[index].importo = f;
            });

            this.f24Stipendi.forEach((f, i) => {
                let data = this.state.date[i];
                var index = 0;

                let stipendio = finalStipendi.find((t, it) => {
                    index = it
                    return t.mese === data
                });
                
                if (!stipendio) {
                    if (f !== '')
                        finalStipendi.push({ mese: data, importo: f });
                } else 
                    finalStipendi[index].importo = f;
            });

            var completed = true 
            let res1 = await editF24Tasse(username, token, JSON.stringify(finalTasse));
            if (res1.result === 'KO') completed = false 

            let res2 = await editF24Ritenute(username, token, JSON.stringify(finalRitenute));
            if (res2.result === 'KO') completed = false 

            let res3 = await editF24Iva(username, token, JSON.stringify(this.f24IVA));
            if (res3.result === 'KO') completed = false 

            let res4 = await editF24Stipendio(username, token, JSON.stringify(finalStipendi));
            if (res4.result === 'KO') completed = false 

            if (!completed) {
                alert("Si è verificato un errore imprevisto durante l'aggiornamento dei dati. Per favore, riprova.");
            }

            this.setState({ isLoading: false });

        }} />

        <div style={{ display: 'flex', marginLeft: -10, marginTop: -30 }}>
          <TextField
            size="small"
            variant="outlined"
            type='text'
            value={this.state.startPeriod}
            style={smallInputStyle}
            onChange={(e) => {
              this.setState({ startPeriod: e.target.value });
            }}
          />

          <img src={require('../images/next.png')} alt="" style={{ width: 20, height: 20, marginTop: 18, marginLeft: 7, opacity: 0.4 }} />

          <TextField
            size="small"
            variant="outlined"
            type='text'
            value={this.state.endPeriod}
            style={smallInputStyle}
            onChange={(e) => {
              this.setState({ endPeriod: e.target.value });
            }}
          />

          <Button
            onClick={() => {
              let start = this.state.startPeriod;
              let end = this.state.endPeriod;

              if (start.length !== 7 || !start.includes("/")) {
                alert('Inserire un valore valido per l\'inizio del periodo (MM/YYYY)')
                return
              }

              if (end.length !== 7 || !end.includes("/")) {
                alert('Inserire un valore valido per la fine del periodo (MM/YYYY)')
                return
              }

              let startD = moment(this.state.startPeriod, 'MM/yyyy');
              let endD = moment(this.state.endPeriod, 'MM/yyyy');

              if (endD.isSameOrBefore(startD)) {
                alert('Inserire una data di fine superiore alla data di inizio.')
                return
              }

              this.generateDate();
              this.reload();
            }}
            style={{ height: 38, marginTop: 9, marginLeft: 10 }}
            variant="contained"
            color="secondary">Aggiorna</Button>

        </div>

        <PageTitle title="F24 Stipendi" />
        <div style={{ width: '100%', overflowX: 'scroll', overflowY: 'hidden' }}>
            <table>
                <tr>
                    { this.state.date.map((d, i) => {

                        return(
                            <th key={i} style={column}>{d}</th>
                        );
                    })}
                </tr>
                <tbody>
                    {this.f24Stipendi.map((s, ind) => {
                        return(
                            <td style={{...column, paddingBottom: 20}}>
                                <input type={'text'} value={s} style={{ width: 150, height: 40, border: '0px', backgroundColor: '#FFFFFF' }} onChange={(e) => this.changeStipendi(ind, e.target.value)} />
                            </td>   
                        );
                    })}
                </tbody>
            </table>
        </div>

        <PageTitle title="F24 Tasse" />
        <div style={{ width: '100%', overflowX: 'scroll', overflowY: 'hidden' }}>
            <table>
                <tr>
                    { this.state.date.map((d, i) => {

                        return(
                            <th key={i} style={column}>{d}</th>
                        );
                    })}
                </tr>
                <tbody>
                    {this.f24tasse.map((s, ind) => {

                        return(
                            <td style={{...column, paddingBottom: 20}}>
                                <input type={'text'} value={s} style={{ width: 150, height: 40, border: '0px', backgroundColor: '#FFFFFF' }} onChange={(e) => this.changeTasse(ind, e.target.value)} />
                            </td>   
                        );
                    })}
                </tbody>
            </table>
        </div>

        <PageTitle title="F24 Ritenute d'acconto" />
        <div style={{ width: '100%', overflowX: 'scroll', overflowY: 'hidden' }}>
            <table>
                <tr>
                    { this.state.date.map((d, i) => {

                        return(
                            <th key={i} style={column}>{d}</th>
                        );
                    })}
                </tr>
                <tbody>
                    {this.f24ritenute.map((s, ind) => {
                        return(
                            <td style={{...column, paddingBottom: 20}}>
                                <input type={'text'} value={s} style={{ width: 150, height: 40, border: '0px', backgroundColor: '#FFFFFF' }} onChange={(e) => this.changeRitenuta(ind, e.target.value)} />
                            </td>   
                        );
                    })}
                </tbody>
            </table>
        </div>

        <PageTitle title="F24 IVA" button="RICALCOLA" onClick={async () => {

            this.setState({isLoading: true});

            let res = await editF24Iva(username, token, JSON.stringify(this.f24IVA));
            if (res.result === 'KO') {
                alert('Si è verificato un errore inatteso. Per favore, riprova.');
                return;
            }
            
            await reloadIVA();
            await this.reload();

        }} />
        <div style={{ width: '100%', overflowX: 'scroll', overflowY: 'hidden' }}>
            <table>
                <tr>
                    { this.state.date.map((d, i) => {

                        return(
                            <th key={i} style={column}>
                                <div style={{ display: 'flex' }}>
                                    <p>{d}</p>
                                    {this.f24IVA[i].edited === '1' && <img src={require('../images/close_ic.png')} alt="" style={{ width: 15, height: 15, marginLeft: 10, marginTop: 17, cursor: 'pointer' }} onClick={() => {
                                        this.f24IVA[i].edited = '0';
                                        this.setState({});
                                    }} />}
                                </div>
                            </th>
                        );
                    })}
                </tr>
                <tbody>
                    {this.f24IVA.map((s, ind) => {

                        return(
                            <td style={{...column, paddingBottom: 20 }}>
                                <input type={'text'} value={s.importo} style={{ width: 150, height: 40, border: '0px', backgroundColor: '#FFFFFF' }} onChange={(e) => this.changeIVA(ind, e.target.value)} />
                            </td>   
                        );
                    })}
                </tbody>
            </table>
        </div>


      </div>
    );
  }
}

const smallInputStyle = {
    borderRadius: 4,
    width: '20%',
    marginLeft: 5,
    paddingTop: 9,
    paddingBottom: 9,
    paddingInline: 9,
    outlineColor: '#4A4A4A',
    outlineWidth: "thin"
  }

const firstColumn = {
    minWidth: 50, 
    maxWidth: 50, 
    textAlign: 'left', 
    width: 50, 
    height: 40, 
}

const column = {
    minWidth: 150, 
    maxWidth: 150, 
    textAlign: 'left', 
    width: 150, 
    height: 40, 
}